/**
 *
 * @param {string} value - value from input
 * @return {string} value with anything non-numerical removed
 *
 * Takes a string and strips anything not a number from it
 */
function deformatNumber(value) {
  return value.replace(/\D/g, '');
}

export default deformatNumber;



// WEBPACK FOOTER //
// ./scripts/svelte/calculators/util/deformatNumber.js